import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HeaderLayout from '../components/common/Header/Header';
import AccountActivation from '../components/login/AccountActivation';
import AnnoucementsUI from '../components/main/announcements/Annoucements';
import CessationPlan from '../components/main/cessationPlan';
import DealPayment from '../components/main/dealPayment/DealPayment';
import DealDetails from '../components/main/deals/DealDetails';
//import DealList from '../components/main/deals/Deals';
import Investments from '../components/main/Investments/Investments';
//import Referral from '../components/main/Referral/Referral';
import NoMatch from '../components/NoMatch';
import ScrollToTop from '../components/common/ScrollTop';
import PDFView from '../components/main/PDFView/PDFView';
import Repayments from '../components/main/repayments/Repayments';
import ResignAIConsent from '../components/main/resignAgreements/AIConsent';
import ResignNDA from '../components/main/resignAgreements/NDA';
import ResignSubscriptionAgreement from '../components/main/resignAgreements/SubscriptionAgreement';
import SettingsWrapper from '../components/main/settings';
import AIConsent from '../components/main/settings/fragments/AIConsent';
import SubscriptionAgreement from '../components/main/settings/fragments/SubscriptionAgreement';
import Message from '../components/message/Meesage';
//import ReferrralTAC from '../components/main/Referral/ReferralTermsConditions';
import { useSelector } from 'react-redux';
import AccessDenied from '../components/AccessDenied';
import AnniversaryRebate from '../components/BithdayTC';
import LandingPage from '../components/landing/Landing';
import AccountActivationWithOTP from '../components/login/AccountActivationWithOPT';
import FAQ from '../components/main/FAQ';
import InvestmentDetails from '../components/main/Investments/InvestmentDetails';
import ReferralNew from '../components/main/ReferralNew';
import ReferralTermsConditions from '../components/main/ReferralNew/ReferralTC';
import Deals from '../components/main/dealList';
import TermSheetComp from '../components/main/deals/components/TermSheet';
import OnboardingFlow from '../components/main/onboarding/Onbording';
import MyinfoRedirect from '../components/main/onboarding/components/kyc/Signpass/MyinfoRedirect';
import ResignHIPLAIConsent from '../components/main/resignAgreements/HIPLAIConsent';
import PostAgreements from '../components/main/resignAgreements/PostAgreements';
import HIPLAIConsent from '../components/main/settings/fragments/HIPLAIConsent';
import SocailLoginRes from '../components/socialLogin';
import { RootState } from '../store/rootReducer';
import { HEADERMENU_PATH } from './RoutesURL';

const RootRoutes: React.FC = () => {
    const investorType = useSelector((state: RootState) => state.user.investor?.investorType);

    return (
        <BrowserRouter>
            <ScrollToTop>
                <Routes>
                    {/** Login */}
                    <Route path={HEADERMENU_PATH.login} element={<LandingPage />} />
                    {/** End Login */}

                    {/** Sign up */}
                    <Route path={HEADERMENU_PATH.signUp} element={<LandingPage />} />
                    <Route path={HEADERMENU_PATH.signUpSuccess} element={<LandingPage />} />
                    {/**Referral sign up */}
                    <Route path={`${HEADERMENU_PATH.referralSignUp}:referralCode`} element={<LandingPage />} />
                    {/** End Sign up */}

                    {/** Forgot and Reset Password */}
                    <Route path={HEADERMENU_PATH.forgotPassword} element={<LandingPage />} />
                    <Route path={HEADERMENU_PATH.forgotPasswordMessage} element={<LandingPage />} />
                    <Route path={HEADERMENU_PATH.resetPassword} element={<LandingPage />} />
                    <Route path={HEADERMENU_PATH.resendActivateEmail} element={<LandingPage />} />
                    {/** End Forgot and Reset Password */}

                    {/**Account Activation and Set password */}
                    <Route path={HEADERMENU_PATH.accountActivation} element={<AccountActivation />} />
                    <Route path={HEADERMENU_PATH.activateAccountAndSetPassword} element={<AccountActivation />} />
                    {/**End Account Activation and Set password */}

                    {/**Onboarding (Multiple routes) */}
                    <Route path={`${HEADERMENU_PATH.onboarding}/*`} element={<OnboardingFlow />} />
                    {/**End Onboarding */}

                    {/** Social Login Redirect */}
                    <Route path={HEADERMENU_PATH.oauth2} element={<SocailLoginRes />} />
                    {/** End Social Login Redirect */}

                    {/** KYC MyInfo */}
                    <Route path={HEADERMENU_PATH.myinfoRedirect} element={<MyinfoRedirect />} />
                    {/** End KYC MyInfo */}

                    {/** Account Activation With OTP */}
                    <Route path={HEADERMENU_PATH.accountActivationWithOtp} element={<AccountActivationWithOTP />} />
                    {/** End Account Activation With OTP */}

                    {/** Agreements */}
                    <Route path={HEADERMENU_PATH.postAgreements} element={<PostAgreements />} />
                    {/** End Agreements */}

                    {/** NDA and Agreements resign */}
                    <Route path={HEADERMENU_PATH.resignNDA} element={<ResignNDA />} />
                    <Route path={HEADERMENU_PATH.resignAIConsent} element={<ResignAIConsent />} />
                    <Route path={HEADERMENU_PATH.resignSubscription} element={<ResignSubscriptionAgreement />} />
                    <Route path={HEADERMENU_PATH.resignHIPLAIConsent} element={<ResignHIPLAIConsent />} />
                    {/** End NDA and Agreements resign */}

                    {/** Agreements */}
                    <Route path={HEADERMENU_PATH.signHIPLAIConsent} element={<HIPLAIConsent />} />
                    <Route
                        path={HEADERMENU_PATH.signAIConsent}
                        element={investorType === 'Institutional' ? <AccessDenied /> : <AIConsent />}
                    />
                    <Route path={HEADERMENU_PATH.signSubscription} element={<SubscriptionAgreement />} />
                    {/** End Agreements */}

                    <Route element={<HeaderLayout />}>
                        {/** Deals */}
                        <Route path="/" element={<Deals />} />
                        <Route path={HEADERMENU_PATH.deals} element={<Deals />} />
                        {/** Deal Details */}
                        <Route path="/deal/:uuid" element={<DealDetails />} />
                        <Route path="/deal/:uuid/term-sheet" element={<TermSheetComp />} />
                        {/** End Deals */}

                        {/**Setting (Multiple routes) */}
                        <Route path={`${HEADERMENU_PATH.settings}/*`} element={<SettingsWrapper />} />
                        {/**Setting (Multiple routes) */}

                        {/** Investments */}
                        <Route path={HEADERMENU_PATH.investments} element={<Investments />} />
                        <Route path={`${HEADERMENU_PATH.investments}/:uuid`} element={<InvestmentDetails />} />
                        {/** End Investments */}

                        {/** Referral */}
                        <Route path={HEADERMENU_PATH.referral} element={<ReferralNew />} />
                        <Route path={HEADERMENU_PATH.referralTAC} element={<ReferralTermsConditions />} />
                        {/** End Referral */}

                        {/** Deal Payment */}
                        <Route path={`${HEADERMENU_PATH.dealPayment}:uuid`} element={<DealPayment />} />
                        {/** End Deal Payment */}

                        {/** Cessation Plan */}
                        <Route path={HEADERMENU_PATH.cessationPlan} element={<CessationPlan />} />
                        {/** End Cessation Plan */}

                        {/** Repayment */}
                        <Route path={`${HEADERMENU_PATH.repayment}:uuid`} element={<Repayments />} />
                        {/** End Repayment */}

                        {/** PDF View */}
                        <Route path={HEADERMENU_PATH.PDFView} element={<PDFView />} />
                        {/** PDF View */}

                        {/** Anniversary Rebate */}
                        <Route path={HEADERMENU_PATH.rebate} element={<AnniversaryRebate />} />
                        {/** End Anniversary Rebate */}
                        {/**FAQ */}
                        <Route path={HEADERMENU_PATH.faq} element={<FAQ />} />
                        {/**FAQ end*/}
                    </Route>
                    <Route path={HEADERMENU_PATH.accessDenied} element={<AccessDenied />} />
                    <Route path="*" element={<NoMatch />} />
                </Routes>
            </ScrollToTop>
            <Message />
            <AnnoucementsUI />
        </BrowserRouter>
    );
};
export default RootRoutes;
